
import React from 'react';
import { FacilityOrderTemplateDoNotSupplyModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateDoNotSupplyModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateDoNotSupplyModalStore(rootStore, componentProps), 'facilityOrderTemplateDoNotSupplyModalStore')
@observer
class FacilityOrderTemplateDoNotSupplyModal extends React.Component {
    render() {
        return <FacilityOrderTemplateDoNotSupplyModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateDoNotSupplyModal;
